self.onmessage = function (event) {
  const { productId } = event.data;

  if (!productId) {
    self.postMessage({ error: 'Product ID is required.' });
    return;
  }

  const options = {
    method: 'GET',
    headers: { accept: 'application/json', 'Content-Type': 'application/json' },
  };

  fetch(
    `https://api-cdn.yotpo.com/v1/widget/VfGJPW4vPNNSoij4DQTpDjecQLRZ2ec9ayxIgFH1/products/${productId}/reviews.json`,
    options
  )
    .then((response) => {
      if (!response.ok) {
        self.postMessage({
          error: `Yotpo Reviews API request error. Status code: ${response.status}`,
        });
      }

      return response.json();
    })
    .then(({ response: { bottomline, reviews } }) => {
      const structuredDataReviews = (reviews || [])
        .map((review) => ({
          '@type': 'Review',
          name: review.title,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: review.score,
          },
          author: {
            '@type': 'Person',
            name: review.user.display_name,
          },
          reviewBody: review.content,
          datePublished: review.created_at,
        }))
        .sort((a, b) => new Date(b.datePublished) - new Date(a.datePublished))
        .slice(0, 4);

      const ratingCount = bottomline?.total_review || 0;
      const ratingValue = parseFloat((bottomline?.average_score || 0).toFixed(1));

      self.postMessage({
        structuredDataReviews:
          ratingCount && ratingValue && structuredDataReviews.length ? structuredDataReviews : null,
      });
    })
    .catch((error) => {
      self.postMessage({ error: error.message });
    });
};
